// Re-export consolidated locale utilities from config
// This file maintained for backward compatibility - all functions moved to config/locale.config.ts

export {
  getDefaultLocale,
  isSupportedLocale as isValidLocale, // Alias for backward compatibility
  getSupportedLocalesArray as getSupportedLocales,
} from "@/config/locale.config";

import { getDefaultLocale } from "@/config/locale.config";

/**
 * Checks if the specified locale is the default one
 */
export const isDefaultLocale = (locale: string): boolean => {
  const defaultLocale = getDefaultLocale();
  return locale === defaultLocale;
};

/**
 * Создает URL с правильным префиксом локали
 * Для дефолтной локали префикс не добавляется
 */
export const createLocalizedUrl = (locale: string, path: string): string => {
  // Убираем начальный слеш из path если он есть
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;

  if (isDefaultLocale(locale)) {
    return `/${normalizedPath}`;
  }
  return `/${locale}/${normalizedPath}`;
};
